module.exports = __webpack_public_path__ + "img/chevron-right.086f9550.svg";